import Api from '@/services/Index';


const studentRequest = async (data, config, isManual = false) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    const url = isManual ? '/housing/requests/manual' : '/housing/requests';
    return Api.post(url, data, config);
}

const manualRequest = async (data, config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/housing/requests/manual', data, config);
}

export default {
    studentRequest,
    manualRequest
}
